
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeat_pump_balance as ObiHeat_pump_balanceElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heat_pump_balance.js';
 
 
 

 
 export const ObiHeat_pump_balance = createComponent({
   react: React,
   tagName: 'obi-heat_pump_balance',
   elementClass: ObiHeat_pump_balanceElement,
   events: {
     
   }
  });
 
 